import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const Categorys = ({ sellerId, sellerName }) => {
  const { categorys } = useSelector((state) => state.home);
  useEffect(() => {}, [sellerId]);
  if (!sellerName) {
    console.warn('Categorys: sellerName is undefined');
    return null; // or return <div>Loading...</div>;
  }

  // Function to safely create category URL
  const createCategoryUrl = (categoryName) => {
    if (!sellerName) {
      console.warn("sellerName is missing or null");
      return "/";
    }
    return `/${sellerName}/products?category=${encodeURIComponent(categoryName)}`;
  };

  return (
    <div className="w-[87%] mx-auto relative">
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Shop by Category</h2>
            <p className="text-gray-600 mt-1">Discover our wide range of products</p>
          </div>
          <Link
            to={`/${sellerName}/products`}
            className="bg-indigo-600 text-white px-6 py-2 rounded-lg hover:bg-indigo-700 transition-colors duration-200 font-medium text-sm shadow-md hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200"
          >
            View All Products
          </Link>
        </div>
      </div>
      {sellerId ? (
        <div className="flex flex-wrap gap-x-8 gap-y-3 items-center">
          {categorys.map((c, i) => {
            const categoryUrl = createCategoryUrl(c.name);
            return (
              <Link
                className="flex items-center text-base text-gray-800 hover:text-blue-600 transition-colors duration-200"
                key={i}
                to={categoryUrl}
                onClick={(e) => {
                  if (!sellerId) {
                    e.preventDefault();
                    console.warn('Navigation prevented - sellerId is missing');
                  }
                }}
              >
                <img
                  src={c.image}
                  alt={c.name}
                  className="w-6 h-6 object-contain mr-2 inline-block align-middle"
                />
                <span className="align-middle">{c.name}</span>
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="text-center p-4">Loading categories...</div>
      )}
    </div>
  );
};

export default Categorys;
